import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useCustomColors } from '../hooks/useIframe'

export default function Home() {
  const { t } = useTranslation()
  const customColors = useCustomColors()
  return (
    <div className="touch-spacing">
      <div className="card">
        <div className="text-center">
          <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">
            Dobrodošli na projekat Zasadi Drvo
          </h2>
          <p className="text-gray-600 mb-6 text-sm sm:text-base">
            Istražite statistiku prethodnih akcija, pregledajte podatke na mapi i informišite se o budućim akcijama.
          </p>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
            <Link
              to="/statistics"
              className="card hover:opacity-90 transition-opacity group" style={{ backgroundColor: customColors.seed.primary }}
            >
              <div className="text-center">
                <div className="text-4xl mb-3">📊</div>
                <h3 className="text-lg font-semibold text-gray-800 mb-2">
                {t('navigation.statistics')}
                </h3>
                <p className="text-sm text-gray-600">
                  Istražite statistiku prethodnih akcija
                </p>
              </div>
            </Link>
            
            <Link
              to="/map"
              className="card hover:opacity-90 transition-opacity group" style={{ backgroundColor: customColors.background.primary }}
            >
              <div className="text-center">
                <div className="text-4xl mb-3">🗺️</div>
                <h3 className="text-lg font-semibold text-white mb-2">
                {t('navigation.map')}
                </h3>
                <p className="text-sm text-gray-100">
                  Pregledajte podatke na mapi
                </p>
              </div>
            </Link>
          </div>

          <div className="touch-spacing">
            <div className="card">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">
                Ukratko
              </h3>
              <p className="text-gray-700 text-sm text-center">
              Projekat „Zasadi drvo“ koji je 2019. godine pokrenula kompanija WMG (Wireless Media Group), ostvario je prvi zacrtani cilj – istorijskih milion posađenih sadnica širom Srbije. Ovaj uspešan projekat najmasovnije sadnje u Srbiji, postao je simbol zajedništva i ekološke odgovornosti, unapredio je životnu sredinu i inspirisao zajednice širom zemlje da prepoznaju značaj zaštite prirodnih resursa.
              </p>
            </div>
            
            <div className="bg-gray-50 p-4 rounded-lg">
              <a href='https://www.zasadidrvo.rs/' className="text-gray-700 text-sm text-center">www.zasadidrvo.rs</a>
            </div>
            <p></p>
          </div>
        </div>
      </div>
    </div>
  )
}
